import solver from 'solver-utilities';

const ms = 100;
let requests = 1;
let requestsTimeout = null;

/**
 * Sets the intial loading bar width based on number of active requests
 */
const setInitUI = function () {
	const el = document.querySelector('[data-loading]');
	el.setAttribute('data-loading', 'true');

	const width = requests * 10;
	el.style.width = width + '%';
};

/**
 * Finishes remaining width after all requests have been made
 */
const setUI = async function () {
	const el = document.querySelector('[data-loading]');
	el.setAttribute('data-loading', 'true');

	el.style.width = '100%';

	el.setAttribute('data-loading', 'false');
	el.style.width = '0%';
};

/**
 * Listens for http requests
 * @return {Number|Null} Number of request
 */
export const loading = async function () {
	if (!window.fetch) return;

	const mock = window.fetch;

	window.fetch = async function () {
		requests++;

		setInitUI();

		const timeout = requests * ms;
		clearTimeout(requestsTimeout);

		requestsTimeout = setTimeout(() => {
			clearTimeout(requestsTimeout);
			requestsTimeout = null;
			setUI();
		}, timeout);

		const response = await mock.apply(this, arguments);

		if (response && response.status === 200) {
			return response;
		}

		return null;
	};
};
